import Button from '@/components/Buttons/Button';
import { pricingStudioUrl, pricingUrl } from '@/environment';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { PlanGroup } from '@d-id/types';
import { theme } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { TopicRow } from './TopicRow';
import { topicTableColumns } from './TopicsTable';

const TopicTableUpgradeContainer = styled.div`
    position: relative;
    padding: 16px 0;
    gap: 16px;
`;

const UpgradeOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    z-index: 1;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
`;

const Title = styled.div`
    color: ${theme.colors.secondary.main};
    text-align: center;
    font-size: 20px;
    font-weight: 700;
`;

const Content = styled.div`
    color: ${theme.colors.black[700]};
    text-align: center;
    font-size: 14px;
    font-weight: 400;
`;

export const TopicTableUpgrade = () => {
    const mixpanel = useAnalytics();
    const { user } = useAuth();
    const planGroup = user?.planGroup;

    const handleUpgrade = () => {
        mixpanel?.track('upgrade-package', { event: 'click', from: 'agents-insights', plan: planGroup });
        if ([PlanGroup.BUILD, PlanGroup.LAUNCH, PlanGroup.SCALE].includes(planGroup!)) {
            window.open(pricingUrl, '_blank');
        } else {
            window.open(pricingStudioUrl, '_blank');
        }
    };

    return (
        <TopicTableUpgradeContainer>
            <UpgradeOverlay>
                <Title>Upgrade to get access to insights</Title>
                <Content>
                    Get a deeper understanding of your user performance. Track Agent activity,
                    <br />
                    monitor key metrics, and uncover growth opportunities.
                </Content>
                <Button onClick={handleUpgrade}>Upgrade</Button>
            </UpgradeOverlay>

            <TopicRow
                key="1"
                item={{
                    topic: 'Payment Issues',
                    intent: 'Refund Request Refund Request',
                    n_sessions: 15,
                    sessions_change: 12,
                    sessions_sentiment: 'negative',
                    interactions: 15,
                    interactions_change: 12,
                    interactions_sentiment: 'negative',
                    users: 10,
                    users_change: 5,
                    users_sentiment: 'negative',
                    positive_conversation_sentiment_percentage: 70,
                    negative_conversation_sentiment_percentage: 10,
                    total_interactions: 5,
                }}
                onClick={() => {}}
                columns={topicTableColumns}
            />
            <TopicRow
                key="2"
                item={{
                    topic: 'Payment Issues Longer Topic',
                    intent: 'Refund Request Refund Request Refund Request',
                    n_sessions: 15,
                    sessions_change: 12,
                    sessions_sentiment: 'negative',
                    interactions: 15,
                    interactions_change: 12,
                    interactions_sentiment: 'negative',
                    users: 10,
                    users_change: 5,
                    users_sentiment: 'positive',
                    positive_conversation_sentiment_percentage: 70,
                    negative_conversation_sentiment_percentage: 10,
                    total_interactions: 5,
                }}
                onClick={() => {}}
                columns={topicTableColumns}
            />
            <TopicRow
                key="3"
                item={{
                    topic: 'Payment Issues Longer',
                    intent: 'Refund Request',
                    n_sessions: 15,
                    sessions_change: 12,
                    sessions_sentiment: 'negative',
                    interactions: 15,
                    interactions_change: 12,
                    interactions_sentiment: 'positive',
                    users: 10,
                    users_change: 5,
                    users_sentiment: 'positive',
                    positive_conversation_sentiment_percentage: 70,
                    negative_conversation_sentiment_percentage: 10,
                    total_interactions: 5,
                }}
                onClick={() => {}}
                columns={topicTableColumns}
            />
        </TopicTableUpgradeContainer>
    );
};
